<template>
    <v-frontend>
        <v-wrapper :padding="true" element="main">
            <v-box element="section">
                <div class="privacy">
                    <h1>Política de privacidad</h1>
                    <h2>Sobre la recolección de datos y la publicidad.</h2>
                    <p>El usuario, al realizar una consulta por un clasificado, se le pedirá que ingrese en MartillerosUnidos.com algunos datos básicos, como por ejemplo email, nombre y apellido. MartillerosUnidos.com se reserva el derecho de ofrecerle servicios y productos propios y/o de terceros a los fines de mejorar la experiencia de usuarios y clientes, optimizar búsquedas, satisfacer necesidades, brindar información sobre cambios, actualizar novedades y cualquier otro tipo de consulta tendiente a mejorar su experiencia con relación a la tecnología desarrollada en MartillerosUnidos.com. Los datos serán utilizados para tales fines, salvo que sean requeridos legalmente por alguna institución nacional o internacional.</p>
                    <p>Por cualquier duda o consulta relacionada con el uso de datos, el usuario o cliente podrá contactarse utilizando el formulario disponible en el menú principal.</p>
                    <p>MartillerosUnidos.com podrá implementar en etapas de desarrollo y prueba funciones de publicidad de tipo display o remarketing para sus clasificados, anuncios o publicaciones online.</p>
                    <p>Los usuarios podrán inhabilitar y personalizar publicidad display o remarketing del tipo Google Analytics por medio del uso de la herramienta Configuración de Anuncios. Diversos proveedores, incluido Google, pueden mostrar sus anuncios en sitios de Internet, para lo cual podrán utilizarse cookies de origen y cookies de terceros para optimizar anuncios basándose en las visitas previas.</p>
                    <p>Los usuarios podrán configurar o bien abstenerse de utilizar los servicios que no deseen o consideren innecesarios.</p>
                    <p>Se dispone de Términos y Condiciones, a los cuales se puede acceder desde la página principal de MartillerosUnidos.com.</p>
                    <p>Dic 2020.</p>
                </div>
            </v-box>
        </v-wrapper>
    </v-frontend>
</template>

<script>
export default {
    meta: {
        title: 'Política de privacidad',
        titleTemplate: '%s - MartillerosUnidos'
    }
}
</script>

<style lang="scss">
.privacy {
    padding: 2rem;
    h1 {
        margin-bottom: 2rem;
        text-transform: uppercase;
        text-align: center;
        font-weight: 600;
        font-size: 1.8rem;
    }
    h2 {
        margin-bottom: 1rem;
        font-weight: 600;
        font-size: 1.4rem;
    }
    p {
        margin-bottom: 1rem;
        &:last-child {
            margin-bottom: 0;
        }
    }
    @media (max-width: 992px) {
        padding: 1rem;
    }
}
</style>
